<script setup lang="ts">
  import { Modal } from 'bootstrap'
  import IconComponent from '../../../components/Atoms/Icon.vue'
  import { useAR } from '@/store/Pinia/useAR.store'

  import { ref, onMounted } from 'vue'

  const modal = ref<InstanceType<typeof Modal> | null>(null)
  const arStore = useAR()
  const message = ref<string>('')

  const action = ref<() => any>(() => null)

  onMounted(() => {
    modal.value = new Modal('#modal-try-again', {
      backdrop: 'static',
      keyboard: false,
    })
  })

  function show() {
    modal.value?.show()
  }

  function hide() {
    modal.value?.hide()
  }

  function setMessage(messageParam: string): void {
    message.value = messageParam
  }

  function setAction(actionParam: () => any) {
    action.value = actionParam
  }

  function callAction() {
    action.value()
    hide()
  }

  defineExpose({ show, hide, setAction, setMessage })
</script>

<template>
  <div id="modal-try-again" class="modal modal-md fade" tabindex="-1">
    <div class="modal-dialog modal-dialog-centered">
      <div class="modal-content">
        <div class="modal-header pb-3">
          <h5 class="modal-title">Atenção!</h5>

          <button class="btn-close" @click="hide" />
        </div>
        <div v-if="message.trim().length > 0" class="modal-body py-3">
          <img alt="sucesso" src="../assets/warning-notebook-girl.svg" />

          <p class="fs-6 text-start mt-4">
            <strong>{{ message }}</strong>
          </p>
        </div>

        <div v-else class="modal-body py-3">
          <img alt="sucesso" src="../assets/warning-notebook-girl.svg" />

          <p class="fs-6 text-start mt-4">
            Ops! <strong>Parece que ocorreu um problema.</strong>
          </p>

          <p class="fs-6 text-start mt-4">
            Por favor, <strong>aguarde</strong> um momento e
            <strong>tente novamente.</strong>
          </p>

          <div class="contact-wrapper">
            <div class="contact py-3 gap-2">
              <div class="contact-item">
                <span class="color--primary fw-600">
                  Ficou alguma dúvida?
                </span>
              </div>
              <div class="contact-item">
                <icon-component class="icon mx-1" name="phone" />
                <span>{{ arStore.$state.arData.foneAR }}</span>
              </div>
            </div>
          </div>
        </div>
        <div v-if="message.trim().length === 0" class="modal-footer py-3">
          <button class="btn btn-primary" type="button" @click="callAction">
            Tentar novamente
          </button>
        </div>
      </div>
    </div>
  </div>
</template>

<style scoped>
  .modal-title {
    color: red;
  }

  .contact-wrapper {
    display: flex;
    justify-content: center;
    margin-top: 2rem;
    width: 100%;
  }
  .contact {
    display: flex;
    flex-wrap: wrap;
    justify-content: center;
    width: 100%;
    gap: 1rem;
    border: 1px solid #e6e7ec;
    border-radius: 10px;
  }
  .contact-item {
    display: flex;
    align-items: center;
    gap: 0.5rem;
  }

  @media (min-width: 576px) {
    .modal-md {
      --bs-modal-width: 440px;
    }
  }
</style>
